import { AnyTask, Market, TaskRoute } from "tm-shared/types";

export const sortStartVisitFirstTasks = (tasks: AnyTask[]): AnyTask[] => {
    return [...tasks].sort((a, b) => {
        const aIsStart = a.context.route === TaskRoute.StartVisit;
        const bIsStart = b.context.route === TaskRoute.StartVisit;

        if (aIsStart === bIsStart) return 0;
        return aIsStart ? -1 : 1;
    });
};

export const mapMarketForCopy = (market: Market) => ({
    id: market.id,
    name: market.name,
    externalMarketId: market.externalMarketId,
    address: market.address,
    partner: market.partner.name,
    partnerId: market.partner.id,
    type: market.type,
    category: market.category,
    fop: market.contragent.name,
    hasDebt: market.hasDebt,
    hasDebtCritical: market.hasDebtCritical,
});
